<script>
import Layout from '@layouts/main.vue'
import {
  authComputed,
  usersStatsMethods,
  usersStatsComputed,
  cityComputed,
  cityMethods,
} from '@state/helpers'
import dayjs from 'dayjs'
import debounce from 'lodash/debounce'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/lt'

export default {
  page: {
    title: 'Statistika',
  },

  components: { Layout, DatePicker },

  data() {
    return {
      keyword: '',
      city: '',
      sort: 'first_name',
      active: true,
      inactive: false,
      dateRange: [],
      page: 1,
      per_page: 20,
      nv_program: false,
      kc_program: false,
      drauge_program: false,
      grupese_program: false,
      dialogs: {
        filters: {
          visible: false,
        },
        reports: {
          visible: false,
          title: '',
          files: [],
        },
        churn: {
          visible: false,
          city: '',
          active: true,
          inactive: false,
        },
      },
    }
  },

  computed: {
    ...authComputed,

    ...usersStatsComputed,

    ...cityComputed,

    showEventsReport() {
      const isCoordinator = this.currentUser.role === 'coordinator'
      const isAdmin = this.currentUser.role === 'admin' && this.city

      return isCoordinator || isAdmin
    },
  },

  created() {
    this.setFilterDate()
    this.setFilterCity()
    this.fetchData()
    this.fetchAllCities()
  },

  methods: {
    ...usersStatsMethods,

    ...cityMethods,

    setFilterCity() {
      if (this.currentUser.role === 'volunteer') {
        this.city = this.currentUser.city
      }
    },

    setFilterDate() {
      this.dateRange = [
        dayjs().format('YYYY-MM-01'),
        dayjs().format('YYYY-MM-DD'),
      ]
    },

    fetchData() {
      const { keyword, city, active, inactive, page, per_page } = this
      const [start_date, end_date] = this.dateRange

      const params = {
        keyword,
        city,
        active,
        inactive,
        page,
        per_page,
        start_date,
        end_date,
      }

      if (this.nv_program) params.nv_program = this.nv_program
      if (this.kc_program) params.kc_program = this.kc_program
      if (this.drauge_program) params.drauge_program = this.drauge_program
      if (this.grupese_program) params.grupese_program = this.grupese_program

      this.fetchAllUsersStats(params)
    },

    onChangeSearchKeyword: debounce(function () {
      this.fetchData()
    }, 500),

    onClickUsersExcel() {
      this.dialogs.reports.visible = true
      this.dialogs.reports.title = 'Savanorių Excel ataskaitos'
      this.dialogs.reports.files = [
        {
          title: `Nuo ${this.dateRange[0]} iki ${this.dateRange[1]} (dabartinis filtras)`,
          url: `/api/users_stats.xls?${this.downloadsQuery(
            this.dateRange[0],
            this.dateRange[1],
          )}`,
        },
      ]

      const dateFrom = dayjs('2020-06-01') // when this project started
      const dateTo = dayjs()
      const months = dateTo.diff(dateFrom, 'month')
      for (let month = months - 1; month > 0; month -= 1) {
        const startDate = dayjs(dateFrom).add(month, 'month').set('date', 1)
        const endDate = dayjs(startDate).set('date', startDate.daysInMonth())

        this.dialogs.reports.files.push({
          title: `Nuo ${startDate.format('YYYY-MM-DD')} iki ${endDate.format(
            'YYYY-MM-DD',
          )}`,
          url: `/api/users_stats.xls?${this.downloadsQuery(
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
          )}`,
        })
      }
    },

    onClickCitiesExcel() {
      this.dialogs.reports.visible = true
      this.dialogs.reports.title = 'Miestų Excel ataskaitos'
      this.dialogs.reports.files = [
        {
          title: `Nuo ${this.dateRange[0]} iki ${this.dateRange[1]} (dabartinis filtras)`,
          url: `/api/cities_stats.xls?${this.downloadsQuery(
            this.dateRange[0],
            this.dateRange[1],
          )}`,
        },
      ]

      const dateFrom = dayjs('2020-06-01') // when this project started
      const dateTo = dayjs()
      const months = dateTo.diff(dateFrom, 'month')
      for (let month = months - 1; month > 0; month -= 1) {
        const startDate = dayjs(dateFrom).add(month, 'month').set('date', 1)
        const endDate = dayjs(startDate).set('date', startDate.daysInMonth())

        this.dialogs.reports.files.push({
          title: `Nuo ${startDate.format('YYYY-MM-DD')} iki ${endDate.format(
            'YYYY-MM-DD',
          )}`,
          url: `/api/cities_stats.xls?${this.downloadsQuery(
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
          )}`,
        })
      }
    },

    downloadsQuery(startDate, endDate) {
      const { keyword } = this
      return `keyword=${encodeURIComponent(keyword)}&token=${
        this.currentUser.downloads_token
      }&city=${this.city}&start_date=${startDate}&end_date=${endDate}&active=${
        this.active
      }&inactive=${this.inactive}`
    },

    downloadsQueryWithDefaultCity(startDate, endDate) {
      const { keyword } = this
      return `keyword=${encodeURIComponent(keyword)}&token=${
        this.currentUser.downloads_token
      }&city=${
        this.city || this.currentUser.city
      }&start_date=${startDate}&end_date=${endDate}&active=${
        this.active
      }&inactive=${this.inactive}`
    },

    onClickEventsExcel() {
      const [start_date, end_date] = this.dateRange
      window.location = `/api/events_stats.xls?${this.downloadsQueryWithDefaultCity(
        start_date,
        end_date,
      )}`
    },

    onClickChurnModalShow() {
      this.dialogs.churn.visible = true
    },

    onClickContactsExcel() {
      const [start_date, end_date] = this.dateRange
      window.location = `/api/contacts_stats.xls?${this.downloadsQuery(
        start_date,
        end_date,
      )}`
    },

    changePage(page) {
      this.page = page
      this.fetchData()
    },

    onSubmitFilter() {
      this.dialogs.filters.visible = false
      this.page = 1
      this.fetchData()
    },

    onClickDutiesExcel() {
      this.dialogs.reports.visible = true
      this.dialogs.reports.title = 'Grafiko Excel ataskaitos'
      this.dialogs.reports.files = [
        {
          title: `Nuo ${this.dateRange[0]} iki ${this.dateRange[1]} (dabartinis filtras)`,
          url: `/api/duties_stats.xls?${this.downloadsQuery(
            this.dateRange[0],
            this.dateRange[1],
          )}`,
        },
      ]

      const dateFrom = dayjs('2020-06-01') // when this project started
      const dateTo = dayjs()
      const months = dateTo.diff(dateFrom, 'month')
      for (let month = months - 1; month > 0; month -= 1) {
        const startDate = dayjs(dateFrom).add(month, 'month').set('date', 1)
        const endDate = dayjs(startDate).set('date', startDate.daysInMonth())

        this.dialogs.reports.files.push({
          title: `Nuo ${startDate.format('YYYY-MM-DD')} iki ${endDate.format(
            'YYYY-MM-DD',
          )}`,
          url: `/api/duties_stats.xls?${this.downloadsQuery(
            startDate.format('YYYY-MM-DD'),
            endDate.format('YYYY-MM-DD'),
          )}`,
        })
      }
    },

    onClickChurnExcel() {
      const { active, inactive, city } = this.dialogs.churn
      window.location = `/api/churn_stats.xls?active=${active}&inactive=${inactive}&city=${city}&token=${this.currentUser.downloads_token}`
    },
  },
}
</script>

<template>
  <Layout>
    <base-page-title>
      <template v-slot:title>
        <h1 class="text-2xl font-bold">Statistika</h1>
        <div
          v-if="currentUser.role !== 'volunteer' && usersStatsPagination"
          class="text-sm text-gray-600 font-medium -mt-2"
        >
          {{ usersStatsPagination.totalItems | countDisplay }}
        </div>
      </template>
      <template v-slot:actions>
        <div v-if="currentUser.role !== 'volunteer'">
          <div class="flex mb-4">
            <base-input
              v-model="keyword"
              type="text"
              data-cypress-keyword
              placeholder="Paieškos raktažodis..."
              class="w-full input"
              :class="{
                rounded: currentUser.role === 'volunteer',
                'rounded-l': currentUser.role !== 'volunteer',
              }"
              autofocus
              @change="onChangeSearchKeyword"
            />
            <button
              v-if="currentUser.role !== 'volunteer'"
              type="button"
              class="w-12 rounded-r bg-gray-300 text-center cursor-pointer btn-main"
              data-cypress-filter
              @click="dialogs.filters.visible = true"
            >
              <font-awesome-icon :icon="['fas', 'bars']" />
            </button>
          </div>
        </div>
        <div class="lg:ml-4 mb-4 h-8 w-full lg:w-64 datepicker">
          <DatePicker
            v-model="dateRange"
            value-type="format"
            format="YYYY-MM-DD"
            range
            @change="onChangeSearchKeyword"
          />
        </div>
      </template>
    </base-page-title>

    <div class="-mx-4 lg:-mx-8">
      <div class="overflow-x-auto">
        <table v-if="usersStats && usersStats.length" class="table-auto w-full">
          <thead>
            <tr>
              <th class="text-left">Vardas, Pavardė</th>
              <th class="text-center w-40">Išbudėta<br />ligoninėse, val.</th>
              <th class="text-center w-40">Išbudėta<br />KC, val.</th>
              <th class="text-center w-40">Išbudėta<br />grupėse, val.</th>
              <th class="text-center w-40">Kvalifikacijos<br />kėlimo val.</th>
              <th class="text-center w-40">Papildomos<br />val.</th>
              <th class="text-center w-40">Viso<br />val.</th>
              <th class="text-center w-40">Galimybių pamainų,<br />vnt.</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="user in usersStats"
              :key="user.id"
              :class="{ 'bg-gray-100 font-semibold': user.average }"
            >
              <td> {{ user.first_name }} {{ user.last_name }} </td>
              <td class="text-center">
                {{ user.hospital_hours }}
              </td>
              <td class="text-center">
                {{ user.kc_hours }}
              </td>
              <td class="text-center">
                {{ user.grupese_hours }}
              </td>
              <td class="text-center">
                {{ user.event_times }}
              </td>
              <td class="text-center">
                {{ user.additional_hours }}
              </td>
              <td class="text-center">
                {{ user.total_hours }}
              </td>
              <td class="text-center">
                {{ user.availability_times }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <template v-if="currentUser.role !== 'volunteer'">
      <div v-if="usersStats && usersStats.length" class="text-center mt-8">
        <div class="w-full lg:w-64 mb-4 lg:inline-block">
          <base-btn class="p-2" @click="onClickUsersExcel">
            Savanorių statistika
          </base-btn>
        </div>

        <div class="w-full lg:w-64 lg:ml-4 mb-4 lg:inline-block">
          <base-btn class="p-2" @click="onClickCitiesExcel">
            Miestų statistika
          </base-btn>
        </div>

        <div
          v-if="showEventsReport"
          class="w-full lg:w-64 lg:ml-4 mb-4 lg:inline-block"
        >
          <base-btn class="p-2" @click="onClickEventsExcel">
            Renginių statistika
          </base-btn>
        </div>

        <div class="w-full lg:w-64 lg:ml-4 mb-4 lg:inline-block">
          <base-btn class="p-2" @click="onClickChurnModalShow">
            Savanorystės statistika
          </base-btn>
        </div>

        <div class="w-full lg:w-64 lg:ml-4 mb-4 lg:inline-block">
          <base-btn class="p-2" @click="onClickDutiesExcel">
            Grafiko ataskaitos
          </base-btn>
        </div>

        <div class="w-full lg:w-64 lg:ml-4 mb-4 lg:inline-block">
          <base-btn class="p-2" @click="onClickContactsExcel">
            Savanorių kontaktai
          </base-btn>
        </div>
      </div>
    </template>

    <base-pagination :pagination="usersStatsPagination" @change="changePage" />

    <base-dialog
      v-if="dialogs.filters.visible"
      title="Paieškos filtras"
      overlay-closes
      @close="dialogs.filters.visible = false"
    >
      <div v-if="currentUser.role === 'admin'" class="mb-4">
        <base-select
          v-model="city"
          :options="cityOptions || []"
          type="text"
          :blank-option="{ id: '', label: 'Miestas...' }"
        />
      </div>

      <div class="flex flex-col lg:flex-row mb-4">
        <div class="mr-4">
          <base-label-check v-model="nv_program" type="text" label="NV" />
        </div>
        <div class="mr-4">
          <base-label-check v-model="kc_program" type="text" label="KC" />
        </div>
        <div class="mr-4">
          <base-label-check
            v-model="drauge_program"
            type="text"
            label="Drauge"
          />
        </div>
        <div class="mr-4">
          <base-label-check
            v-model="grupese_program"
            type="text"
            label="Grupėse"
          />
        </div>
      </div>

      <div class="flex flex-row">
        <div class="mr-4">
          <base-label-check
            v-model="active"
            type="text"
            label="Rodyti dirbančius"
          />
        </div>
        <div class="mr-4">
          <base-label-check
            v-model="inactive"
            type="text"
            label="Rodyti nedirbančius"
          />
        </div>
      </div>

      <template v-slot:buttons>
        <div class="w-32 ml-4">
          <base-btn class="p-3" @click="onSubmitFilter"> Filtruoti </base-btn>
        </div>
      </template>
    </base-dialog>

    <base-dialog
      v-if="dialogs.reports.visible"
      :title="dialogs.reports.title"
      :overlay-closes="true"
      @close="dialogs.reports.visible = false"
    >
      <div class="-mx-8 overflow-y-scroll" style="max-height: 600px">
        <table class="table-auto w-full">
          <thead>
            <tr>
              <th>Data</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="file in dialogs.reports.files" :key="file.id">
              <td class="py-2">
                <div class="flex flex-col">
                  <div class="flex-grow">
                    <a :href="file.url">
                      {{ file.title }}
                    </a>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </base-dialog>

    <base-dialog
      v-if="dialogs.churn.visible"
      title="Savanorystės statistika"
      overlay-closes
      @close="dialogs.churn.visible = false"
    >
      <div v-if="currentUser.role === 'admin'" class="mb-4">
        <base-select
          v-model="dialogs.churn.city"
          :options="cityOptions || []"
          type="text"
          :blank-option="{ id: '', label: 'Miestas...' }"
        />
      </div>

      <div class="flex flex-row">
        <div class="mr-4">
          <base-label-check
            v-model="dialogs.churn.active"
            type="text"
            label="Rodyti dirbančius"
          />
        </div>
        <div class="mr-4">
          <base-label-check
            v-model="dialogs.churn.inactive"
            type="text"
            label="Rodyti nedirbančius"
          />
        </div>
      </div>

      <template v-slot:buttons>
        <div class="w-32 ml-4">
          <base-btn class="p-3" @click="onClickChurnExcel">
            Parsisiųsti
          </base-btn>
        </div>
      </template>
    </base-dialog>
  </Layout>
</template>
